// Zentrale Design-Werte (Farben, Schrift, Kopfzeile, Footer) – Standardwerte = bisheriges Aussehen der Website.
export const COLOR_DEFS = [
  { key: "brand", label: "Primärgrün", hex: "#2d6b0d", hint: "Buttons, Links, Icons, Überschriften-Akzente" },
  { key: "brand_hover", label: "Primärgrün Hover", hex: "#1e4a08", hint: "Buttons beim Überfahren" },
  { key: "brand_dark", label: "Primärgrün dunkel", hex: "#245609", hint: "Speichern-Buttons, Verläufe" },
  { key: "brand_deep", label: "Dunkelgrün (Kleinüberschriften)", hex: "#2f5a12", hint: "Kleine Großbuchstaben-Zeilen, Portal-Buttons" },
  { key: "gold", label: "Gold-Akzent", hex: "#d9a63a", hint: "Sterne, Insel-Label auf Kacheln" },
  { key: "sun", label: "Gelb (Hero-Zeile 2)", hex: "#f0b400", hint: "Kursive Zeile im Titelbild" },
  { key: "signal", label: "Rot (Objekt-Nr., Angebote)", hex: "#d00000", hint: "Objektnummer, Last-Minute, Gutschein-Code" },
  { key: "badge_offer", label: "Bild-Badge Angebot / Last-Minute", hex: "#d00000", hint: "Rote Marken auf den Objektfotos („−10 % Last Minute“, „21 Nächte buchen, 17 bezahlen“)" },
  { key: "badge_instant", label: "Bild-Badge Sofortbuchung", hex: "#2d6b0d", hint: "Marke „Sofortbuchung“ auf den Objektfotos" },
  { key: "badge_new", label: "Bild-Badge Neu", hex: "#d9a63a", hint: "Marke „Neu“ auf den Objektfotos" },
  { key: "line", label: "Linien hellgrün", hex: "#cfe0bf", hint: "Rahmen, Trennlinien" },
  { key: "soft", label: "Hellgrün Flächen", hex: "#dae8ce", hint: "Chips, Hervorhebungen" },
  { key: "tint", label: "Zartgrün Hintergrund", hex: "#f3f7ee", hint: "Boxen, Info-Flächen" },
  { key: "page", label: "Seitenhintergrund", hex: "#f7faf3", hint: "Hintergrund aller Seiten" },
  { key: "ink", label: "Textfarbe", hex: "#333333", hint: "Fließtext" },
  { key: "footer_light", label: "Footer hell (Newsletter)", hex: "#b7cc8f", hint: "Oberster Footer-Streifen" },
  { key: "footer_mid", label: "Footer mittel", hex: "#578226", hint: "Hauptbereich des Footers" },
  { key: "footer_dark", label: "Footer dunkel", hex: "#336b0f", hint: "Unterste Leiste, Social-Icons" },
  { key: "trash", label: "Papierkorb", hex: "#b91c1c", hint: "Papierkorb-Knöpfe – gilt sofort nach dem Speichern", admin: true },
];

export const FONTS = [
  ["Open Sans", "300;400;500;600;700;800"], ["Lato", "300;400;700;900"], ["Roboto", "300;400;500;700"], ["Montserrat", "300;400;500;600;700;800"],
  ["Poppins", "300;400;500;600;700"], ["Nunito", "300;400;600;700;800"], ["Nunito Sans", "300;400;600;700;800"], ["Source Sans 3", "300;400;600;700"],
  ["Raleway", "300;400;500;600;700"], ["Work Sans", "300;400;500;600;700"], ["DM Sans", "400;500;600;700"], ["Manrope", "300;400;500;600;700;800"],
  ["Inter", "300;400;500;600;700"], ["Quicksand", "300;400;500;600;700"], ["Josefin Sans", "300;400;600;700"], ["Mulish", "300;400;600;700;800"],
  ["Rubik", "300;400;500;600;700"], ["Karla", "300;400;500;600;700"], ["Fira Sans", "300;400;500;600;700"], ["Cabin", "400;500;600;700"], ["PT Sans", "400;700"],
  ["Playfair Display", "400;500;600;700;800"], ["Merriweather", "300;400;700;900"], ["Lora", "400;500;600;700"], ["Libre Baskerville", "400;700"],
];

export const DESIGN_DEFAULTS = {
  claim_show: true, claim_text: "CANARIAS", claim_color: "#946600", claim_size: 14, claim_tracking: 0.15, claim_italic: true, claim_weight: 600, claim_x: 0, claim_y: 0,
  logo_height: 76, header_height: 80, header_bg: "#faf8f5", header_bg_opacity: 82, header_blur: 14,
  font_body: "Open Sans", font_heading: "Open Sans", font_base: 16, heading_scale: 100, heading_weight: 600, h1_scale: 100, h2_scale: 100, h3_scale: 100,
  hero_height: 92, hero_overlay: 100, home_section_gap: 40,
  footer_heading_color: "#ffffff", footer_heading_size: 18, footer_line_show: true, footer_line_color: "#ffffff", footer_text_color: "#ffffff",
  ...Object.fromEntries(COLOR_DEFS.map((c) => [`color_${c.key}`, c.hex])),
};
export const DESIGN_KEYS = Object.keys(DESIGN_DEFAULTS);

/** Abschnittsabstand Startseite (Design → Startseite, Schieber in px): vertikaler Innenabstand je Abschnitt; Abstand unter der Überschrift = 60 %. Alte Werte klein/mittel/groß werden umgerechnet. */
const LEGACY_GAPS = { small: 40, medium: 64, large: 80 };
export const homeGapPx = (v) => { const n = typeof v === "string" && LEGACY_GAPS[v] ? LEGACY_GAPS[v] : Number(v); return Number.isFinite(n) && n > 0 ? n : 40; };

/** Design-Wert lesen: leer/null = Standard. */
export const dv = (s, k) => { const v = s?.[`design_${k}`]; return v === "" || v == null ? DESIGN_DEFAULTS[k] : v; };

const HEX6 = /^#[0-9a-fA-F]{6}$/;
export const isHex = (v) => HEX6.test(v || "");
export const hexToRgb = (hex) => { const h = isHex(hex) ? hex : "#000000"; return [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16)).join(" "); };
export const hexToHsl = (hex) => {
  const [r, g, b] = hexToRgb(hex).split(" ").map((n) => Number(n) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  if (max === min) return `0 0% ${Math.round(l * 100)}%`;
  const d = max - min, s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  const h = max === r ? ((g - b) / d + (g < b ? 6 : 0)) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return `${Math.round(h * 60)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

const loadedFonts = new Set(["Open Sans"]);
export const ensureFont = (name) => {
  if (!name || loadedFonts.has(name)) return;
  const def = FONTS.find(([n]) => n === name);
  if (!def) return;
  loadedFonts.add(name);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${name.replace(/ /g, "+")}:wght@${def[1]}&display=swap`;
  document.head.appendChild(link);
};

const VARS = (s) => {
  const c = (k) => hexToRgb(dv(s, `color_${k}`));
  const h = (k) => hexToHsl(dv(s, `color_${k}`));
  return {
    ...Object.fromEntries(COLOR_DEFS.map(({ key }) => [`--c-${key.replace(/_/g, "-")}`, c(key)])),
    "--primary": h("brand"), "--ring": h("brand"), "--secondary": h("soft"), "--secondary-foreground": h("brand_hover"), "--border": h("line"), "--input": h("line"),
    "--background": h("page"), "--foreground": h("ink"), "--destructive": h("signal"), "--muted": h("tint"),
    "--font-body": `"${dv(s, "font_body")}"`, "--font-heading": `"${dv(s, "font_heading")}"`, "--font-heading-weight": String(dv(s, "heading_weight")),
    "--font-base": `${dv(s, "font_base")}px`, "--hs-all": String(Number(dv(s, "heading_scale")) / 100),
    "--h1s": String(Number(dv(s, "h1_scale")) / 100), "--h2s": String(Number(dv(s, "h2_scale")) / 100), "--h3s": String(Number(dv(s, "h3_scale")) / 100),
    "--header-bg": hexToRgb(dv(s, "header_bg")), "--header-bg-a": String(Number(dv(s, "header_bg_opacity")) / 100), "--header-blur": `${dv(s, "header_blur")}px`, "--header-h": `${dv(s, "header_height")}px`,
    "--home-sec-py": `${homeGapPx(dv(s, "home_section_gap"))}px`, "--home-sec-head": `${Math.round(homeGapPx(dv(s, "home_section_gap")) * 0.6)}px`,
  };
};

/** Setzt (on) bzw. entfernt (off → Standard aus index.css) alle Design-Variablen am <html>; Admin-Farben (z. B. Papierkorb) gelten immer. */
const ALWAYS = new Set(COLOR_DEFS.filter((c) => c.admin).map((c) => `--c-${c.key.replace(/_/g, "-")}`));
export const applyTheme = (s, on) => {
  const root = document.documentElement;
  const vars = VARS(s || {});
  Object.entries(vars).forEach(([k, v]) => (on || ALWAYS.has(k) ? root.style.setProperty(k, v) : root.style.removeProperty(k)));
  if (on) { ensureFont(dv(s, "font_body")); ensureFont(dv(s, "font_heading")); }
};
